import logo from './logo.svg';
import './App.css';

import React, { useEffect, useState } from 'react';

import Admin from './Admin';
import * as API from './api/api';

function App() {

  const [email, setEmail] = useState(localStorage.getItem('email') ||  null);
  const [firstName, setFirstName] = useState(localStorage.getItem('firstName') ||  null);
  const [lastName, setLastName] = useState(localStorage.getItem('lastName') ||  null);
  const [className, setClassName] = useState(localStorage.getItem('className') ||  null);
  
  const [userToken, setUserToken] = useState(localStorage.getItem('userToken'));
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));
  const [sessionCode, setSessionCode] = useState(localStorage.getItem('sessionCode') || '');

  const [sessionData, setSessionData] = useState(null);

  const [PIN, setPIN] = useState(null);

  console.log('App state:', { email, firstName, lastName, className, userToken, adminToken, sessionCode, sessionData });

  function handleRegistration(event) {
    event.preventDefault();
    const email = document.getElementById('email').value;
    const firstName = document.getElementById('firstName').value;
    const lastName = document.getElementById('lastName').value;
    const className = document.getElementById('className').value;
    setPIN(null);

    API.Register(email, firstName + ' ' + lastName).then(response => {
      if(response.status){
        setFirstName(firstName);
        setLastName(lastName);
        setClassName(className);
        setEmail(email);
        localStorage.setItem('email', email);
        localStorage.setItem('userName', firstName);
        localStorage.setItem('firstName', firstName);
        localStorage.setItem('lastName', lastName);
        localStorage.setItem('className', className);

        if(response.PIN) {
          setPIN(response.PIN);
        }
      }
    });
  }

  function CapturePINCode(event, i) {
     const value = event.target.value;
     const charInputs = Array.from(document.querySelectorAll('.one-char-input'));

     if (value.length === 1 && i < charInputs.length - 1) {
          document.querySelector(`[data-index="${i + 1}"]`).focus();
      }
      // check if all inputs are filled
      const allFilled = Array.from(document.querySelectorAll('.one-char-input')).every(input => input.value.length === 1);
      if (allFilled) {
          const pin = Array.from(document.querySelectorAll('.one-char-input')).map(input => input.value).join('');
          console.log('Entered PIN:', pin);

          API.ConfirmUser(email, firstName, lastName, className, pin).then(response => {
            if (response.userToken) {
              setUserToken(response.userToken);
              localStorage.setItem('userToken', response.userToken);
              if(response.adminToken) {
                setAdminToken(response.adminToken);
                localStorage.setItem('adminToken', response.adminToken);
              }
            } else {
              document.getElementById('invalidPIN').style.display = 'block';
              // Clear inputs for retry
              document.querySelectorAll('.one-char-input').forEach(input => input.value = '');
              document.querySelector(`[data-index="0"]`).focus();
            }
          });
      }
  }
  function CaptureSessionCode(event, i) 
  {
     const value = event.target.value;
     const charInputs = Array.from(document.querySelectorAll('.one-char-input'));

     if (value.length === 1 && i < charInputs.length - 1) {
          document.querySelector(`[data-index="${i + 1}"]`).focus();
      }
      // check if all inputs are filled
      const allFilled = Array.from(document.querySelectorAll('.one-char-input')).every(input => input.value.length === 1);
      if (allFilled) {
          const code = Array.from(document.querySelectorAll('.one-char-input')).map(input => input.value).join('');
          console.log('Entered Session Code:', code);

          API.LoadSession(code).then(response => {
            if (response.success) {
              setSessionCode(response.sessionCode);
              localStorage.setItem('sessionCode', response.sessionCode);
            } else {
              document.getElementById('statusMessage').style.display = 'block';
              // Clear inputs for retry
              document.querySelectorAll('.one-char-input').forEach(input => input.value = '');
              document.querySelector(`[data-index="0"]`).focus();
            }
          });
      }
  }

  useEffect(() => {
    setTimeout(() => {
      const firstInput = document.querySelector(`[data-index="0"]`);
      if (firstInput) {
        firstInput.focus();
      } 
    }, 300);

      if(sessionCode) {
        API.GetSessionData(sessionCode).then(response => {
          if (response.status === 'active' || response.status === 'submitted') {
            setSessionData(response);
            console.log('Session loaded');
          } else {
            console.error('Failed to load session data');
              setSessionCode('');
          }
        });
      }
      
    }, [firstName, userToken, sessionCode]);

    function toggleButton(event, quizId, answerId) {
      const button = event.target;
      const quiz = button.getAttribute('data-quiz');
      const answer = button.getAttribute('data-answer');
      console.log(`Quiz ${quiz}, Answer ${answer} selected`);

      if (button.classList.contains('selected')) {
        button.classList.remove('selected');
      } else {
        button.classList.add('selected');
      }
    }

    function submitAnswers() {
      const selectedAnswers = [];
      document.querySelectorAll('.answer-btn.selected').forEach(button => {
        const quiz = button.getAttribute('data-quiz');
        const answer = button.getAttribute('data-answer');

        // search for quiz in sessionData, and append answer to existing quiz entry, otherwise create new entry
        const existingQuiz = selectedAnswers.find(q => q.quiz === quiz);
        if (existingQuiz) {
          existingQuiz.answer += ',' + answer;
        } else {
          selectedAnswers.push({ quiz, answer });
        }
      });
      console.log('Submitting answers:', selectedAnswers);
      // Here you would typically send the selected answers to the server via an API call

      API.SubmitAnswers({ sessionCode: sessionCode, answers: selectedAnswers }).then(response => {
        if (response.success) {
          API.GetSessionData(sessionCode).then(response => {
          console.log('API Response:', response);
            setSessionData(response);
        });
        } else {
          alert('Failed to submit answers. Please try again.');
        }
      });
    } 

    function askForLogout() {
      if (window.confirm('Are you sure you want to log out?')) {
        setFirstName(null);
        setLastName(null);
        setClassName(null);
        setUserToken(null);
        setAdminToken(null);
        setSessionCode('');
        setSessionData(null);
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('className');
        localStorage.removeItem('userToken');
        localStorage.removeItem('adminToken');
        localStorage.removeItem('sessionCode');
      }
    } 

    function askForExitSession() {
      if (window.confirm('Are you sure you want to exit the session?')) {
        setSessionCode('');
        setSessionData(null);
        localStorage.removeItem('sessionCode');
      }
    } 

  const letters = ['A', 'B', 'C', 'D', 'E', 'F'];

  return (
    <div className="App">
      {firstName && (
      <div id="header">
            {firstName && (<div id="user-name" onClick={askForLogout}>{firstName}</div>)}
            {sessionCode && (<div id="session-code" onClick={askForExitSession}>{sessionCode}</div>)}
        </div>
        )}
        <div id="content">

          { !firstName && (
            <div className="form-container form-container-500 white-background padding20">
                <h2>Register</h2>
                <form id="registrationForm">
                    <div className="form-group">
                        <label for="firstName">First Name</label>
                        <input type="text" id="firstName" required />
                    </div>
                    <div className="form-group">
                        <label for="lastName">Last Name</label>
                        <input type="text" id="lastName" required />
                    </div>
                    <div className="form-group">
                        <label for="className">Class Name</label>
                        <input type="text" id="className" required />
                    </div>
                    <div className="form-group">
                        <label for="email">Email</label>
                        <input type="email" id="email" required />
                    </div>
                    <button type="submit" className="btn-height45" onClick={handleRegistration}>Register</button>
                </form>
                <div className="cookie-consent">
                    By registering, you agree to our use of cookies
                </div>
            </div>
          )}

          { firstName && !userToken && (
              <div className="form-container form-container-500 white-background padding20">
                <h2>Enter PIN</h2>
                <p style={{ "text-align": "center", "margin-bottom": "20px", "color": "#666" }}>
                    Enter the 5-digit code sent to <b>{email}</b> to confirm your registration.
                </p>
                <div className="otp-container" id="otpContainer">
                    {Array(5).fill(0).map((_, i) => (
                        <input key={i} type="text" className="one-char-input" maxLength="1" data-index={i} onChange={(e) => CapturePINCode(e, i)} />
                    ))}

                </div>
                <div id="invalidPIN" className="invalid-pin" style={{ "display": "none" }}>
                    Invalid PIN, please try again.
                </div>
                <div>
                    <p style={{ "text-align": "center", "margin-top": "20px", "color": "#666" }}>
                        Didn't receive the code? Please check your spam folder or contact support.
                    </p>
                    {PIN && (
                        <p style={{ "text-align": "center", "margin-top": "20px", "color": "#28a745" }}>
                            Your registration was successful! Your PIN code is: <b>{PIN}</b>. Please enter this code on the next screen to confirm your registration.
                        </p>
                    )}
                </div>
             </div>
           )}

          { adminToken && ( <Admin /> ) }

          { !adminToken && userToken && !sessionCode && (
            <div className="form-container form-container-500 white-background padding20">
                <h2>Enter Session Code</h2>
                <div className="otp-container" id="otpContainer">
                {Array(6).fill(0).map((_, i) => (
                        <input key={i} type="text" className="one-char-input" maxLength="1" data-index={i} onChange={(e) => CaptureSessionCode(e, i)} />
                    ))}
                </div>
                <div id="statusMessage" className="status-message"></div>
            </div>
          )}

          { !adminToken && sessionCode && !sessionData && (
             <div className="form-container form-container-500white-background padding20">
                <p style={{ textAlign: 'center' }}>Loading session data...</p>
              </div>
          )}

          { !adminToken && sessionData && (
                <div>
                {sessionData.status === 'submitted' && (
                  <div className="form-container form-container-500 white-background padding20">
                    <h2>Your points: {sessionData.points3}</h2>
                    <p style={{ textAlign: 'center' }}>Your answers have been submitted. Thank you for participating!</p>
                  </div>
                )}
                {sessionData.status === 'active' && (
                  <div>
                    <h3>Quizzes:</h3>
                    <div className="form-container" style={{ maxWidth: '1200px' }}>
                        <div className="quiz-grid" id="quizGrid">
                          {sessionData.quizzes.map((quiz, index) => (
                            <div key={index} className="quiz-card">
                              <div className="quiz-title">Question {quiz.quiz}</div>
                                      <img src={quiz.image} alt={`Question ${quiz.quiz}`} className="quiz-image" onError={() => (document.querySelector('.quiz-image').src = `https://picsum.photos/300/200?random={index}`)} />
                                      <div className="quiz-content">
                                          
                                          <div className="answer-buttons" data-quiz="{quiz.quiz}">
                                              {Array(quiz.answers).fill(0).map((_, i) => (
                                                  <button onClick={(e) => toggleButton(e, quiz.quiz, i + 1)} key={i} 

                                                    className="answer-btn" data-quiz={quiz.quiz} data-answer={letters[i]}>
                                                      {letters[i]}
                                                  </button>
                                              ))}
                                          </div>
                                      </div>
                                  </div>
                          ))}
                        </div>
                        <div className="submit-container">
                            <button className="submit-btn btn-height45" id="submitAnswers" onClick={submitAnswers}>Submit Answers</button>
                        </div>
                    </div>
                  </div>
                )}
                </div>
          )}
              
          
        </div>
    </div>
  );
}

export default App;
